/**
 * Create Advanced Filter web component.
 * Use this component to render Advanced Filter element
 */
class SHTAdvancedFilter extends HTMLElement {
  /**
   * constructor
   */
  constructor() {
    super();
    this.elems = {
      form_elem: this.querySelector("form"),
    };
    this.product_grid_container_selector = "ProductGridContainer";
    this.active_search_terms_selector = `[data-type="search-terms"]`;
    this.details_selector = `[data-type="details-element"]`;
    this.product_count_selector = `[data-type="product-count"]`;
    this.product_grid_selector = "product-grid";
    this.filter_count_hidden = `[data-advanced-search-type="filter-count-hidden"]`;
    this.filter_count_show = `[data-advanced-search-type="filter-count-show"]`;

    this.pathname = window.location.pathname;
    this.form_elem_id = this.elems.form_elem.getAttribute("id");
    this.sort_by_select_elm = document.querySelector(
      `#sort-by-${this.form_elem_id}`
    );
    this.bindEventHandlers();
    this.cachedResults = [];
    this.onActiveSearchTermClickHandle =
      this.onActiveSearchTermClickHandle.bind(this);
  }

  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.elems.form_elem.addEventListener(
      "input",
      this.debounce(this.onFormInputHandle, 500).bind(this)
    );

    this.sort_by_select_elm.addEventListener(
      "input",
      this.debounce(this.onFormInputHandle, 500).bind(this)
    );
  }
  /**
   * Handle on Input event on inputs
   * @param Event e
   */
  onFormInputHandle(e) {
    e.preventDefault();
    this.onFormSubmitHandle(e);
  }
  /**
   * Handle on form submit event
   * @param Event e
   */
  onFormSubmitHandle(e) {
    let formElem = this.elems.form_elem;
    let formData = new FormData(formElem);
    let searchParams = new URLSearchParams(formData).toString();
    this.renderResults(searchParams, e);
  }
  /**
   * Render Results
   *
   * @param string searchParams
   * @param Event event
   * @returns
   */
  renderResults(searchParams, event) {
    let url = this.buildURL(searchParams);
    let cache = this.getReturnedResultsFromCache(url);
    this.toggleLoading(true);
    if (cache) {
      let refinedHTML = this.refineReturnedResults(cache);
      this.renderReturnedResults(refinedHTML, searchParams);
      this.renderActiveSearchTerms(cache, event);
      this.renderProductCount(cache);
      if(window.screen.width < 769) {
        this.renderSortOption(cache);
      }
      return;
    }

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        let html = responseText;
        let refinedHTML = this.refineReturnedResults(html);
        this.renderReturnedResults(refinedHTML, searchParams);
        this.addReturnedResultsToCache(url, html);
        this.renderActiveSearchTerms(html, event);
        this.renderProductCount(html);
        this.renderFilterCount(html);
        if(window.screen.width < 769) {
          this.renderSortOption(html);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
  /**
   * Add result to cache
   * @param string url
   * @param string html
   */
  addReturnedResultsToCache(url, html) {
    this.cachedResults = [...this.cachedResults, { html, url }];
  }
  /**
   * Get the result from cache
   * @param string url
   */
  getReturnedResultsFromCache(url) {
    let filterDataUrl = (element) => element.url === url;
    if (this.cachedResults.some(filterDataUrl)) {
      return this.cachedResults.find(filterDataUrl).html;
    }

    return false;
  }
  /**
   * Refine the result
   * @param string url
   */
  refineReturnedResults(html) {
    const resultsMarkup = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById(this.product_grid_container_selector).innerHTML;
    return resultsMarkup;
  }
  /**
   * Render returned results
   *
   * @param string html
   * @param string searchParams
   */
  renderReturnedResults(html, searchParams) {
    document.getElementById(this.product_grid_container_selector).innerHTML =
      html;
    this.updateURL(searchParams);
    this.toggleLoading(false);
  }
  /**
   * Render active search terms
   * @param string html
   * @param Event event
   * @returns
   */
  renderActiveSearchTerms(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    let activeSearchTerms = parsedHTML.querySelector(
      this.active_search_terms_selector
    );
    if (!activeSearchTerms) return;

    let detailsElements = parsedHTML.querySelectorAll(this.details_selector);

    let matchesDetailsElement = (element) => {
      let closestDetailsElement = event
        ? event.target.closest(this.details_selector)
        : undefined;

      return closestDetailsElement
        ? element.dataset.index === closestDetailsElement.dataset.index
        : false;
    };

    let detailsElementsToRender = Array.from(detailsElements).filter(
      (element) => !matchesDetailsElement(element)
    );

    detailsElementsToRender.forEach((element) => {
      document.querySelector(
        `[data-index="${element.dataset.index}"]${this.details_selector}`
      ).innerHTML = element.innerHTML;
    });

    document.querySelector(this.active_search_terms_selector).innerHTML =
      activeSearchTerms.innerHTML;
  }
  /**
   * Build url for search
   * @param String searchParams
   * @returns
   */
  buildURL(searchParams) {
    let sections = this.getSections();
    let url = null;
    sections.forEach((section) => {
      url = `${this.pathname}?section_id=${section.section}&${searchParams}`;
    });

    return url;
  }
  /**
   * Set a function run after a specific time
   * @param function fn
   * @param number wait
   * @returns
   */
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  /**
   * Get Sections from result
   * @returns  array
   */
  getSections() {
    return [
      {
        section: document.getElementById(this.product_grid_selector).dataset.id,
      },
    ];
  }
  /**
   * Update URL on browser
   * @param String searchParams
   */
  updateURL(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${this.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }
  /**
   * Handle on search term click event
   * @param Event e
   */
  onActiveSearchTermClickHandle(e) {
    let url =
      e.currentTarget.href.indexOf("?") == -1
        ? ""
        : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
    this.renderResults(url);
  }
  /**
   * Add/remove loading prop to web component
   * @param boolean loading
   * @returns
   */
  toggleLoading(loading) {
    if (loading) {
      this.setAttribute("loading", true);
    } else {
      this.removeAttribute("loading");
    }
    return;
  }
  /**
   * Render total of results
   * @param string html
   */
  renderProductCount(html) {
    let count = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(this.product_count_selector).innerHTML;
    let product_count = document.querySelectorAll(this.product_count_selector);
    product_count.forEach(el => {
      el.innerHTML = count;
    })
    // this.querySelector(this.product_count_selector).innerHTML = count;
  }

  /**
   * Render option selected of results
   * @param string html
   */
     renderSortOption(html) {
      let option = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(`[data-selected="option"]`).innerHTML;
      let sort_selected = document.querySelector(`[data-advanced-sort-selected="sort-option"]`);
      sort_selected.innerHTML = option;
    }

    
  /**
   * Render total of Filter
   * @param string html
   */
  renderFilterCount(html) {
    let filterCountElement = document.querySelector(this.filter_count_show);
    if (!filterCountElement) return;
    let filterCountElementSource = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(this.filter_count_hidden);
    if (!filterCountElementSource) return;
    filterCountElement.innerHTML = filterCountElementSource.innerHTML;
  }
}

// Register to the Browser from `customElements` API
customElements.define("sht-advanced-filter", SHTAdvancedFilter);
